<template>
  <div>
    <FeaturedFacial v-if="this.slug === 'facial'" />
  </div>
</template>

<script>
import FeaturedFacial from "@/components/featured/facial";
export default {
  components: { FeaturedFacial },
  data() {
    return {
      slug: this.$route.params.slug,
    };
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/pages/FeaturedDetail.vue